import gql from 'graphql-tag';

import GraphQLClient from '../../adapter/GraphQLClient';

class OtpRecoveryCodeWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ idGraphqlClient }: { idGraphqlClient: GraphQLClient }) {
    this.graphqlClient = idGraphqlClient;
  }

  public get = async (): Promise<string[]> => {
    const result = await this.graphqlClient.query(
      gql`
        query otpRecoveryCodes {
          otpRecoveryCodes
        }
      `,
    );
    return result.otpRecoveryCodes;
  };

  public regenerate = async (): Promise<string[]> => {
    const result = await this.graphqlClient.query(
      gql`
        mutation createOtpRecoveryCodes {
          createOtpRecoveryCodes
        }
      `,
    );
    return result.createOtpRecoveryCodes;
  };
}

export default OtpRecoveryCodeWebApi;
